export default "__VITE_PUBLIC_ASSET__0cac3716__"